import { CARDS, CLASSES } from "../game/content";
import type { CardInstance, GameState } from "../game/types";
import { getCardCost } from "../game/engine";
import { CardArt } from "./Art";

const TYPE_LABEL: Record<string, string> = { attack: "ATTACK", skill: "SKILL", power: "POWER", status: "STATUS", curse: "CURSE" };

export function CardView({
  cardId,
  instance,
  state,
  onPlay,
  disabled = false,
  compact = false,
  selected = false,
}: {
  cardId?: string;
  instance?: CardInstance;
  state?: GameState;
  onPlay?: () => void;
  disabled?: boolean;
  compact?: boolean;
  selected?: boolean;
}) {
  const id = cardId ?? instance?.cardId;
  if (!id) return null;
  const card = CARDS[id];
  const upgraded = Boolean(instance?.upgraded);
  const palette = card.classId === "neutral" ? ["#987f5b", "#e5c783", "#211e1a"] as [string, string, string] : CLASSES[card.classId].palette;
  const cost = instance && state ? getCardCost(state, instance) : card.cost;
  const text = upgraded ? card.upgradedDescription : card.description;
  const className = `game-card ${card.type} ${card.rarity} ${compact ? "compact" : ""} ${disabled ? "disabled" : ""} ${selected ? "selected" : ""}`;
  return (
    <button className={className} onClick={onPlay} disabled={disabled || !onPlay} aria-label={`${card.name}. Cost ${cost}. ${text}`}>
      <div className="card-chrome" style={{ "--card-primary": palette[0], "--card-accent": palette[1], "--card-dark": palette[2] } as React.CSSProperties}>
        <div className="card-cost">{cost < 0 ? "—" : cost}</div>
        <div className="card-name">{card.name}{upgraded ? <span className="upgrade-mark">+</span> : null}</div>
        <div className="card-art"><CardArt art={card.art} palette={palette} label={card.name} /></div>
        <div className="card-type">{TYPE_LABEL[card.type]} · {card.rarity.toUpperCase()}</div>
        <div className="card-rules">{text}</div>
        {!compact && <div className="card-flavor">“{card.flavor}”</div>}
      </div>
    </button>
  );
}
